<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between pb-3>
      <h2>Add predefined view</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{ err }}
    </v-alert>
    <div>
      <v-layout row wrap align-start justify-space-between>
        <v-flex xs12 px-2>
          <v-select
            label="View"
            :items="filteredViews"
            item-text="name.en"
            item-value="name.en"
            v-model="newView"
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submit()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MassRemoveModal",
  props: ['filteredViews'],
  data() {
    return {
      err: '',
      language: this.$cookie.get('lang') || 'en',
      languages: [
        {
          text: "English",
          value: "en"
        },
        {
          text: "German",
          value: "de"
        },
        {
          text: "Chinese",
          value: "zh"
        }
      ],
      newView: null,
    }
  },
  watch: {
    err(val) {
      if (val !== '') {
        setTimeout(() => {
          this.err = '';
        }, 5000);
      }
    },
  },
  created() {

  },
  methods: {
    submit() {
      this.$emit('submit', this.filteredViews.find(x => x.name.en === this.newView));
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AddPredefinedViews.vue?fc2c841a